/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

import { ICodeableConcept } from '@ahryman40k/ts-fhir-types/lib/R4';

const ICD10_SYSTEMS = new Set(['http://hl7.org/fhir/sid/icd-10', 'http://hl7.org/fhir/sid/icd-10-cm']);

export function getIcd10Codes(concept: ICodeableConcept | undefined): string[] {
  return [
    ...new Set(
      concept?.coding
        ?.filter((coding) => coding.system && ICD10_SYSTEMS.has(coding.system) && coding.code)
        .map((coding) => coding.code!) ?? []
    ),
  ];
}
